import {
    FETCH_INVOICE_ESTIMATE_STARTED,
    FETCH_INVOICE_ESTIMATE_SUCCEEDED,
    FETCH_INVOICE_ESTIMATE_FAILED,
} from "../actions/types/invoice.types";
// invoiceEstimateState
const initialState = {
    estimates: [],
    initialEstimates: [],
    fetchEstimateState: "idle",
    addEstimateState: "idle",
    deleteState: "idle",
    updateEstimateState: "idle",
    searchEstimateByFilterState: "idle",
    estimateErrorMessage: "",
};

const invoiceEstimateReducer = (state = initialState, { type, payload }) => {
    switch (type) {

        case FETCH_INVOICE_ESTIMATE_STARTED:
            return {
                ...state,
                fetchEstimateState: "loading",
            };

        case FETCH_INVOICE_ESTIMATE_SUCCEEDED: {
            const data = Array.isArray(payload?.data) ? payload.data : [];

            return {
                ...state,
                fetchEstimateState: "success",
                estimates: data,
                initialEstimates: data,
            };
        }

        case FETCH_INVOICE_ESTIMATE_FAILED:
            return {
                ...state,
                fetchEstimateState: "failed",
            };

 
        // case UPDATE_INVOICE_DRAFT_SUCCEEDED: {
        //     return {
        //         ...state,
        //         updateDraftState: "success",
        //     };
        // }

        // case UPDATE_INVOICE_DRAFT_FAILED: {
        //     return {
        //         ...state,
        //         updateDraftState: "failed",
        //         draftErrorMessage: payload,
        //     };
        // }

        // case RESET_UPDATE_INVOICE_DRAFT_STATE: {
        //     return {
        //         ...state,
        //         updateDraftState: "idle",
        //     };
        // }

        default:
            return state;
    }
};

export { invoiceEstimateReducer };
